export enum NetworkAffiliation {
    OwnedAndOperated = 'OwnedAndOperated',
    Syndicated = 'Syndicated'
}